import { compression } from "./imageCompression";
import {
  MAX_IMAGE_SIZE_BYTES,
  DEFAULT_COMPRESSION_OPTIONS,
  PROFILE_IMAGE_COMPRESSION_OPTIONS,
} from "../constants/imageUpload";
import { messages } from "../constants/messages";

// 元ファイルが上限を超えていればエラー文言、そうでなければ null（ちょうど上限は OK）
export const validateImageSize = (file) =>
  file.size > MAX_IMAGE_SIZE_BYTES ? messages.imageTooLarge : null;

// フィールドごとの圧縮設定（Issue #157）。プロフィール画像だけ小さくする
export const getCompressionOptions = (fieldName) =>
  fieldName === "profileImage"
    ? PROFILE_IMAGE_COMPRESSION_OPTIONS
    : DEFAULT_COMPRESSION_OPTIONS;

// サイズ判定 → 圧縮。成功時は { file }、失敗時は { error }
export const prepareImageFile = async (file, fieldName) => {
  const sizeError = validateImageSize(file);
  if (sizeError) return { error: sizeError };

  try {
    const compressed = await compression(
      file,
      getCompressionOptions(fieldName),
    );
    if (!compressed) return { error: messages.imageProcessFailed };
    return { file: compressed };
  } catch (error) {
    return { error: messages.imageProcessFailed };
  }
};
